
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Spinner from 'vux/src/components/spinner/index.vue'


import util from '@/javascript/util'
import bus from '@/javascript/bus'
import validate from '@/javascript/validate'
import goBack from '@/components/public-components/goBack/index.vue'

export default {
components: {
Group,
Cell,
XInput,
XButton,
Toast,
Spinner,
goBack
},
data () {
return {
minHeight: 0,
maxValue: 6,
phoneNumber: '',
mobileCoder: '',
toast: {
text: '',
show: false
},
coderBtn: {
text: '获取验证码',
state: true
},
spinnerShow: false,
wxUserInfo: {},
}
},
beforeCreate () {
if (bus.userInfo.access_token) {
this.$router.replace({ name: 'center-default' })
}
},
mounted () {
this.minHeight = document.documentElement.clientHeight
},
methods: {
getMobileCoder () {
if (validate.Mobile(this.phoneNumber)) {
if (!this.coderBtn.state) {
return
} else {
this.spinnerShow = true
this.$http.post('/api/wtcp-sms/public/sms/sendCaptcha?phone=' + this.phoneNumber + '&frontAppCode=121001').then((response) => {
const resData = response.data
if (resData.status == 1) {
console.log(resData, '成功');
let time = 60
const self = this,
timer = setInterval(() => {
if (time > 1) {
time--
self.coderBtn.text = time + '秒后重发'
self.coderBtn.state = false
self.spinnerShow = false
} else {
self.coderBtn.text = '获取验证码'
self.coderBtn.state = true
clearInterval(timer)
}
}, 1000)
} else {
console.log(response, '失败');
this.spinnerShow = false
this.toast.text = '该手机号短信数已达今日上限'
this.toast.show = true
}
})
}
} else {
this.toast.text = '请输入正确手机号码'
this.toast.show = true
}
},
login () {
const _this = this
if (!validate.Mobile(_this.phoneNumber)) {
_this.toast.text = '请输入正确手机号码'
_this.toast.show = true
} else if (_this.mobileCoder === '') {
_this.toast.text = '请输入验证码'
_this.toast.show = true
} else {
if (localStorage.getItem('wxUserInfo') != null && localStorage.getItem('wxUserInfo') != '') {
_this.wxUserInfo = JSON.parse(localStorage.getItem('wxUserInfo'))
const param = {
'deptCode': _this.DEPT_CODE.DEPTCODE,
'phone': _this.phoneNumber,
'validateCode': _this.mobileCoder,
'unionId': _this.wxUserInfo.unionid
}
_this.$http.post('/api/wtcp-oauth/wx/userRelation?deptCode=' + _this.DEPT_CODE.DEPTCODE, param).then((response) => {
const resData = response.data
if (resData.status === 0) {
_this.toast.text = resData.data
_this.toast.show = true
} else {

localStorage.removeItem('numberNo')
_this.$http.get('/api/wtcp-oauth/wx/userRelation/' + _this.wxUserInfo.unionid + '?deptCode=' + this.DEPT_CODE.DEPTCODE).then((res) => {
if (res.data.data.access_token) {

bus.$set(bus, 'userInfo', res.data.data)
localStorage.setItem('userInfo', JSON.stringify(res.data.data))
_this.$nextTick(function () {
_this.$router.push({ name: 'center' })
})
}
})
}
})
}
}
}
},
created () {
localStorage.removeItem('wxLoginTime')
}
}
